<template>
<div>
  <PageTitle :route="$route" />

  <PageRowWrapper>
    <OsPreview v-if="os" :os="os" />
    <LoadingPage v-if="!os"/>
  </PageRowWrapper>

</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import OsPreview from '@/components/os/OsPreview'
import LoadingPage from '@/components/spinner/LoadingPage'

export default {
  name: 'Preview',
  components: {
    PageTitle,
    PageRowWrapper,
    OsPreview,
    LoadingPage
  },
  computed: {
    ...mapState({
      os: state => state.os.osById
    })
  },
  methods: {
    ...mapActions('os', ['fetchById', 'cleanState'])
  },
  mounted () {
    this.fetchById(this.$route.params.id)
  },
  destroyed () {
    this.cleanState()
  }
}
</script>
